// extracted by mini-css-extract-plugin
module.exports = {"pillCluster":"pill-cluster_pillCluster__SscjQ","heading":"pill-cluster_heading__06vxu","cluster":"pill-cluster_cluster__RTJMH"};